import { hooks } from 'botframework-webchat';
import React, { useCallback, useState } from 'react';
const { useSuggestedActions, usePostActivity, useScrollToEnd } = hooks;
export const BFFActivityReactionButtons = (props) => {
    var _a;
    const scrollToBottom = useScrollToEnd();
    const postActivity = usePostActivity();
    const [reactionAdded, setReactionAdded] = useState();
    const [suggestedActions] = useSuggestedActions();
    const handleReactionButton = useCallback((event) => {
        const reaction = event.currentTarget.getAttribute('data-reaction');
        const intentId = event.currentTarget.getAttribute('data-intent-id');
        const activityId = props === null || props === void 0 ? void 0 : props.activityId;
        if (reaction != null && intentId != null && activityId) {
            postActivity(buildReactionActivity(reaction, intentId, activityId));
            setReactionAdded(reaction);
            scrollToBottom();
        }
    }, [props === null || props === void 0 ? void 0 : props.activityId, setReactionAdded, scrollToBottom, setReactionAdded]);
    return (React.createElement(React.Fragment, null, (_a = props === null || props === void 0 ? void 0 : props.reactions) === null || _a === void 0 ? void 0 : _a.map((reaction) => (React.createElement("button", { key: reaction.type, onClick: handleReactionButton, disabled: suggestedActions.length || reactionAdded, "aria-label": reaction.spokenLabel || reaction.label, "data-reaction": reaction.type, "data-intent-id": reaction.intentId, "data-chosen": reactionAdded == reaction.type }, reaction.label)))));
};
const buildReactionActivity = (type, intentId, replyToId) => ({
    type: 'messageReaction',
    reactionsAdded: [
        {
            type,
            intentId
        }
    ],
    replyToId
});
//# sourceMappingURL=bffActivityReactionButtons.js.map